import React, { useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const QuillEditor = ({ value, onChange, placeholder, height = "120px" }) => {
	const containerStyle = {
		border: '1px solid #ccc',
		borderRadius: '4px',
		overflow: 'hidden',
	};

	const editorStyle = {
		height: height,
		border: 'none'
	};

	const modules = {
		toolbar: [
			[{ header: 2 }],
			['bold', 'italic', 'underline'],
			[{ list: 'bullet' }],
			[{ align: [] }],
			// [{ 'table': [] }],
			['clean']
		],
	};

	return (
		<div style={containerStyle}>
			<ReactQuill
				placeholder={placeholder}
				theme="snow"
				value={value}
				onChange={onChange}
				style={editorStyle}
				modules={modules}
			/>
		</div>
	);
};

export default QuillEditor;
